import i18n from "../i18n";

export function formatDateTime(input: string | Date): string {
    const date = input instanceof Date ? input : new Date(input);

    if (isNaN(date.getTime())) {
        console.warn("Invalid date passed to formatDateTime:", input);
        return "";
    }

    return new Intl.DateTimeFormat(i18n.language, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    }).format(date);
}

// Wandelt "2025-02-28T12:00:00Z" → "2025-02-28T13:00" (lokale datetime-local Eingabe)
export function utcToLocalInput(utcString: string | null | undefined): string {
    if (!utcString) return "";
    const date = new Date(utcString);
    const tzOffset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - tzOffset).toISOString().slice(0, 16);
}

// Wandelt "2025-02-28T13:00" (local) → "2025-02-28T12:00:00Z"
export function localInputToUtc(localString: string): string {
    const date = new Date(localString);
    return date.toISOString();
}

export function isNowInRange(startUtc: string, endUtc: string): boolean {
    const start = new Date(startUtc); // UTC → Date
    const end = new Date(endUtc);     // UTC → Date
    const now = new Date();           // lokale Zeit → automatisch in UTC intern

    return now >= start && now <= end;
}

export function isDateInPast(utcString: string): boolean {
    const date = new Date(utcString); // UTC
    return date.getTime() < Date.now();
}
